import React from 'react';
import { Hero } from '../components/Hero';
import { ServicePlan } from '../components/ServicePlan';
import { CheckCircle, Clock, Star, Shield } from 'lucide-react';
export const Home = () => {
  return <div data-id="element-390">
      <Hero data-id="element-391" />
      <section className="py-12 bg-gray-50" data-id="element-392">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-393">
          <div className="text-center" data-id="element-394">
            <h2 className="text-3xl font-extrabold text-gray-900 sm:text-4xl" data-id="element-395">
              Welcome to Suretask
            </h2>
            <p className="mt-4 max-w-2xl text-xl text-gray-500 mx-auto" data-id="element-396">
              Your trusted partner for professional appliance repairs and
              maintenance across the UK.
            </p>
          </div>
          <div className="mt-10" data-id="element-397">
            <div className="grid grid-cols-1 gap-8 sm:grid-cols-2 lg:grid-cols-4" data-id="element-398">
              <div className="bg-white overflow-hidden shadow rounded-lg" data-id="element-399">
                <div className="px-4 py-5 sm:p-6" data-id="element-400">
                  <div className="flex items-center" data-id="element-401">
                    <div className="flex-shrink-0 bg-rose-900 rounded-md p-3" data-id="element-402">
                      <CheckCircle className="h-6 w-6 text-white" data-id="element-403" />
                    </div>
                    <div className="ml-5" data-id="element-404">
                      <h3 className="text-lg font-medium text-gray-900" data-id="element-405">
                        Reliable Service
                      </h3>
                      <p className="text-sm text-gray-500" data-id="element-406">
                        Fast, efficient repairs by qualified engineers.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <div className="bg-white overflow-hidden shadow rounded-lg" data-id="element-407">
                <div className="px-4 py-5 sm:p-6" data-id="element-408">
                  <div className="flex items-center" data-id="element-409">
                    <div className="flex-shrink-0 bg-rose-900 rounded-md p-3" data-id="element-410">
                      <Clock className="h-6 w-6 text-white" data-id="element-411" />
                    </div>
                    <div className="ml-5" data-id="element-412">
                      <h3 className="text-lg font-medium text-gray-900" data-id="element-413">
                        Quick Response
                      </h3>
                      <p className="text-sm text-gray-500" data-id="element-414">
                        Appointments within 24-48 hours.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <div className="bg-white overflow-hidden shadow rounded-lg" data-id="element-415">
                <div className="px-4 py-5 sm:p-6" data-id="element-416">
                  <div className="flex items-center" data-id="element-417">
                    <div className="flex-shrink-0 bg-rose-900 rounded-md p-3" data-id="element-418">
                      <Star className="h-6 w-6 text-white" data-id="element-419" />
                    </div>
                    <div className="ml-5" data-id="element-420">
                      <h3 className="text-lg font-medium text-gray-900" data-id="element-421">
                        Expert Engineers
                      </h3>
                      <p className="text-sm text-gray-500" data-id="element-422">
                        Highly trained professionals you can trust.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <div className="bg-white overflow-hidden shadow rounded-lg" data-id="element-423">
                <div className="px-4 py-5 sm:p-6" data-id="element-424">
                  <div className="flex items-center" data-id="element-425">
                    <div className="flex-shrink-0 bg-rose-900 rounded-md p-3" data-id="element-426">
                      <Shield className="h-6 w-6 text-white" data-id="element-427" />
                    </div>
                    <div className="ml-5" data-id="element-428">
                      <h3 className="text-lg font-medium text-gray-900" data-id="element-429">
                        Peace of Mind
                      </h3>
                      <p className="text-sm text-gray-500" data-id="element-430">
                        Fixed-price plans with no hidden costs.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="py-12" data-id="element-431">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-432">
          <div className="text-center" data-id="element-433">
            <h2 className="text-3xl font-extrabold text-gray-900 sm:text-4xl" data-id="element-434">
              Our Service Plans
            </h2>
            <p className="mt-4 max-w-2xl text-xl text-gray-500 mx-auto" data-id="element-435">
              Choose the perfect cover for your appliances with our
              comprehensive service plans.
            </p>
          </div>
          <div className="mt-10 grid grid-cols-1 gap-y-10 gap-x-6 sm:grid-cols-2 lg:grid-cols-3" data-id="element-436">
            <ServicePlan title="One-Year Service Plan – 1 Appliance" price="£99.00" description="Reliable cover for your appliance with 12 months of unlimited repairs, priority support, and expert engineer care." imageUrl="https://uploadthingy.s3.us-west-1.amazonaws.com/dsnNUERxvqDU9cCQPXUGFu/04._Dishawasher_.png" stripeLink="https://buy.stripe.com/eVqaEZgIw3Bn3dwa5HeZ200" data-id="element-437" />
            <ServicePlan title="One-Year Service Plan – TV + Set-Top Box" price="£120.00" description="Protect your home entertainment with unlimited repairs and rapid-response service for your TV and set-top box." imageUrl="https://uploadthingy.s3.us-west-1.amazonaws.com/amw2GdJG5sG5qhMNR4LxDp/5.png" stripeLink="https://buy.stripe.com/5kQ14pdwk0pb29s91DeZ201" data-id="element-438" />
            <ServicePlan title="Two-Year Service Plan – 1 Appliance" price="£150.00" description="Extended two-year protection delivering unlimited repairs, priority service, and lasting reliability from expert engineers." imageUrl="https://uploadthingy.s3.us-west-1.amazonaws.com/bXncqhgaCJJYo6cvrxJCZP/6.png" stripeLink="https://buy.stripe.com/fZudRb77W0pb9BUcdPeZ202" data-id="element-439" />
          </div>
        </div>
      </section>
      <section className="py-12 bg-rose-900 text-white" data-id="element-440">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-441">
          <div className="lg:grid lg:grid-cols-2 lg:gap-8 items-center" data-id="element-442">
            <div data-id="element-443">
              <h2 className="text-3xl font-extrabold sm:text-4xl" data-id="element-444">
                Protect the Items in Your Home
              </h2>
              <p className="mt-4 text-lg" data-id="element-445">
                At Suretask, we understand how important your household
                appliances are to your daily life. That's why our team of highly
                skilled and experienced technicians is committed to delivering
                exceptional repair services you can rely on.
              </p>
              <p className="mt-4 text-lg" data-id="element-446">
                We don't just fix appliances, we provide lasting solutions that
                keep your home running smoothly and efficiently. When you choose
                Suretask, you gain more than just expert repairs.
              </p>
              <p className="mt-4 text-lg" data-id="element-447">
                Our comprehensive service plans are designed to offer you
                complete peace of mind, covering your appliances with reliable
                protection and prompt support whenever you need it. We
                prioritise transparency, honesty, and clear communication, so
                you always know what to expect.
              </p>
              <p className="mt-4 text-lg" data-id="element-448">
                Join the thousands of satisfied customers who trust Suretask for
                dependable, professional, and friendly service. With us, your
                appliances, and your home, are in safe hands.
              </p>
            </div>
            <div className="mt-10 lg:mt-0" data-id="element-449">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/3oPRXccWdVkQcL5Ue5WqVj/02._fridge.png" alt="Family in kitchen with refrigerator" className="rounded-lg shadow-xl" data-id="element-450" />
            </div>
          </div>
        </div>
      </section>
      <section className="py-12 bg-gray-50" data-id="element-451">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-452">
          <div className="text-center" data-id="element-453">
            <h2 className="text-3xl font-extrabold text-gray-900 sm:text-4xl" data-id="element-454">
              Why Choose Suretask?
            </h2>
          </div>
          <div className="mt-10 grid grid-cols-1 gap-10 sm:grid-cols-2 lg:grid-cols-3" data-id="element-455">
            <div className="bg-white p-6 rounded-lg shadow-md" data-id="element-456">
              <h3 className="text-xl font-bold text-rose-900 mb-3" data-id="element-457">
                UK-Wide Coverage
              </h3>
              <p className="text-gray-600" data-id="element-458">
                We provide service across the UK, ensuring help is never far
                away when you need it.
              </p>
            </div>
            <div className="bg-white p-6 rounded-lg shadow-md" data-id="element-459">
              <h3 className="text-xl font-bold text-rose-900 mb-3" data-id="element-460">
                Experienced Engineers
              </h3>
              <p className="text-gray-600" data-id="element-461">
                Our technicians are fully qualified and experienced in repairing
                all major appliance brands.
              </p>
            </div>
            <div className="bg-white p-6 rounded-lg shadow-md" data-id="element-462">
              <h3 className="text-xl font-bold text-rose-900 mb-3" data-id="element-463">
                Transparent Pricing
              </h3>
              <p className="text-gray-600" data-id="element-464">
                No hidden costs or surprise fees. We're upfront about our
                pricing from the start.
              </p>
            </div>
            <div className="bg-white p-6 rounded-lg shadow-md" data-id="element-465">
              <h3 className="text-xl font-bold text-rose-900 mb-3" data-id="element-466">
                Rapid Response
              </h3>
              <p className="text-gray-600" data-id="element-467">
                Quick appointments, usually within 24-48 hours of your call.
              </p>
            </div>
            <div className="bg-white p-6 rounded-lg shadow-md" data-id="element-468">
              <h3 className="text-xl font-bold text-rose-900 mb-3" data-id="element-469">
                Comprehensive Cover
              </h3>
              <p className="text-gray-600" data-id="element-470">
                Our service plans include all labour costs and replacement parts
                when available.
              </p>
            </div>
            <div className="bg-white p-6 rounded-lg shadow-md" data-id="element-471">
              <h3 className="text-xl font-bold text-rose-900 mb-3" data-id="element-472">
                Customer Satisfaction
              </h3>
              <p className="text-gray-600" data-id="element-473">
                We're committed to providing excellent service that keeps our
                customers coming back.
              </p>
            </div>
          </div>
        </div>
      </section>
    </div>;
};